<template>
  <Popup v-bind="$attrs" v-on="$listeners">
    <div class="authenPopupBox">
      <div class="authenPopupText">您还没绑定企业，请先绑定</div>
    </div>
  </Popup>
</template>
<script>
import Popup from './Popup.vue';

export default {
  name: 'bindingEnterprisePopup',
  data() {
    return {};
  },
  components: {
    Popup,
  },
  methods: {
    clickImgCode() {
      this.$emit('sendPicCode');
    },
  },
};
</script>
<style scoped>
.authenPopupBox {
  text-align: left;
}
.authenPopupTip {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #001f33;
  margin-bottom: 12px;
}
.authenPopupText {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  color: #001F33;
  letter-spacing: 0;
}
</style>
